// extracted by mini-css-extract-plugin
export default {"profileTypeListContainer":"styles_profileTypeListContainer__bNrmr","profileTypesContainer":"styles_profileTypesContainer__9wXZL"};